import api from "../../infra/api";

class Analises {
    async ListarSolicitacoesDeAcesso(codigoSolicitacao, filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? `/api/v1/AnaliseSolicitacao?page=1&start=0&limit=999
                        &fields=["Id","CodigoSolicitacao","Sequencia","DataApresentacao","ParecerDocumentos","DataDocumento","MotReprovDocumento","RessalvaDocumento","ParecerEquipamento","DataEquipamento","MotReprovEquipamento","RessalvaEquipamento","ParecerProjeto","DataProjeto","MotReprovProjeto","RessalvaProjeto","ParecerViabTecnica","DataViabTecnica","MotReprovViabTecnica","RessalvaViabTecnica","ParecerGeral","Situacao","GerarObra","DataAnalise","DataPrazo","CodigoDocumentoParecer","SolicitacaoDeAcesso.Id","SolicitacaoDeAcesso.CodigoResponsavelTec","SolicitacaoDeAcesso.CodigoTipoGeracao","SolicitacaoDeAcesso.ResponsavelTec.Id","SolicitacaoDeAcesso.ResponsavelTec.Situacao","SolicitacaoDeAcesso.ResponsavelTec.Email","SolicitacaoDeAcesso.ResponsavelTec.Nome","SolicitacaoDeAcesso.ResponsavelTec.Empresa","SolicitacaoDeAcesso.ResponsavelTec.DddFone","SolicitacaoDeAcesso.ResponsavelTec.Celular","SolicitacaoDeAcesso.ResponsavelTec.CPF","SolicitacaoDeAcesso.ResponsavelTec.Crea","SolicitacaoDeAcesso.ResponsavelTec.DataValidadeCrea","SolicitacaoDeAcesso.ResponsavelTec.Ativo","SolicitacaoDeAcesso.ResponsavelTec.DataCadastro","SolicitacaoDeAcesso.ResponsavelTec.DataAprovacaoCadastro","SolicitacaoDeAcesso.ResponsavelTec.DataPrazoAnalise","SolicitacaoDeAcesso.ResponsavelTec.DataEnvioSolicitacao"]
                        &filter=[{"property":"CodigoSolicitacao","operator":"equal","value":"${codigoSolicitacao}","and":true}]&sort=[{"property":"Id","direction":"DESC"}]`
                : `/api/v1/AnaliseSolicitacao?page=1&start=0&limit=999
                        &fields=["Id","CodigoSolicitacao","Sequencia","DataApresentacao","ParecerDocumentos","DataDocumento","MotReprovDocumento","RessalvaDocumento","ParecerEquipamento","DataEquipamento","MotReprovEquipamento","RessalvaEquipamento","ParecerProjeto","DataProjeto","MotReprovProjeto","RessalvaProjeto","ParecerViabTecnica","DataViabTecnica","MotReprovViabTecnica","RessalvaViabTecnica","ParecerGeral","Situacao","GerarObra","DataAnalise","DataPrazo","CodigoDocumentoParecer","SolicitacaoDeAcesso.Id","SolicitacaoDeAcesso.CodigoResponsavelTec","SolicitacaoDeAcesso.CodigoTipoGeracao","SolicitacaoDeAcesso.ResponsavelTec.Id","SolicitacaoDeAcesso.ResponsavelTec.Situacao","SolicitacaoDeAcesso.ResponsavelTec.Email","SolicitacaoDeAcesso.ResponsavelTec.Nome","SolicitacaoDeAcesso.ResponsavelTec.Empresa","SolicitacaoDeAcesso.ResponsavelTec.DddFone","SolicitacaoDeAcesso.ResponsavelTec.Celular","SolicitacaoDeAcesso.ResponsavelTec.CPF","SolicitacaoDeAcesso.ResponsavelTec.Crea","SolicitacaoDeAcesso.ResponsavelTec.DataValidadeCrea","SolicitacaoDeAcesso.ResponsavelTec.Ativo","SolicitacaoDeAcesso.ResponsavelTec.DataCadastro","SolicitacaoDeAcesso.ResponsavelTec.DataAprovacaoCadastro","SolicitacaoDeAcesso.ResponsavelTec.DataPrazoAnalise","SolicitacaoDeAcesso.ResponsavelTec.DataEnvioSolicitacao"]
                        &filter=[{"property":"CodigoSolicitacao","operator":"equal","value":"${codigoSolicitacao}","and":true}, {"property":"DataApresentacao","operator":"greaterOrEqual","value":"${filtro}","and":true}]`
        });

        return response.data;
    }

    async ListarAnalisesConsultaPrevia(codigoConsultaPrevia, filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? `/api/v1/ConsultaPreviaAnalise?page=1&start=0&limit=999
                    &fields=["Id","CodigoConsultaPrevia","CodigoVisual","TipoAnalise","Parecer","DataAnalise","Usuario","MotivoReprovacao","Ressalva", "Protocolo"]
                    &filter=[{"property":"CodigoConsultaPrevia","operator":"equal","value":"${codigoConsultaPrevia}","and":true}]
                    &sort=[{"property":"DataAnalise","direction":"DESC"}]`
                : `/api/v1/ConsultaPreviaAnalise?page=1&start=0&limit=999
                    &fields=["Id","CodigoConsultaPrevia","CodigoVisual","TipoAnalise","Parecer","DataAnalise","Usuario","MotivoReprovacao","Ressalva", "Protocolo"]
                    &filter=[{"property":"CodigoConsultaPrevia","operator":"equal","value":"${codigoConsultaPrevia}","and":true},{"property":"DataAnalise","operator":"greaterOrEqual","value":"${filtro}","and":true}]
                    &sort=[{"property":"DataAnalise","direction":"DESC"}]`
        });
    
        return response.data;
    }

    async ListarAnalisesAnaliseProjeto(codigoAnaliseProjeto, filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? `/api/v1/AnaliseProjetoAnalise?page=1&start=0&limit=999
                    &fields=["Id","CodigoAnaliseProjeto","CodigoVisual","TipoAnalise","Parecer","DataAnalise","Usuario","MotivoReprovacao","Ressalva", "Protocolo", "ConsultaPrevia.CodigoVisual"]
                    &filter=[{"property":"CodigoAnaliseProjeto","operator":"equal","value":"${codigoAnaliseProjeto}","and":true}]
                    &sort=[{"property":"DataAnalise","direction":"DESC"}]`
                : `/api/v1/AnaliseProjetoAnalise?page=1&start=0&limit=999
                    &fields=["Id","CodigoAnaliseProjeto","CodigoVisual","TipoAnalise","Parecer","DataAnalise","Usuario","MotivoReprovacao","Ressalva", "Protocolo", "ConsultaPrevia.CodigoVisual"]
                    &filter=[{"property":"CodigoAnaliseProjeto","operator":"equal","value":"${codigoAnaliseProjeto}","and":true},{"property":"DataAnalise","operator":"greaterOrEqual","value":"${filtro}","and":true}]
                    &sort=[{"property":"DataAnalise","direction":"DESC"}]`
        });
    
        return response.data;
    }

    async ListarSolicitacoesCompartilhamentoAnalise(codigoResp, codigoSolicCompart, filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? `/api/v1/SolicitacaoCompartilhamentoAnalise?page=1&start=0&limit=9999
                        &fields=["CodigoSolicCompart","CodigoVisual","Id","Analise","Situacao","CodigoResponsavelTecnico","CodigoOcupante","Usuario","CodigoCidade","Bairro","TipoCabo","NomeRepresentante","CpfRepresentante","EmailRepresentante","QtdePontos","DataCadastro","DataApresentacao","PrazoAnalise","PrazoAvisoInstalacao","DataInicioInstalacao","DataTerminoInstalacao","DataAprovacao","ParecerRepresentante","DataParecerRepresentante","ObservacaoRepresentante","ParecerProjeto","DataParecerProjeto","ObservacaoProjeto","ParecerDocumentos","DataParecerDocumentos","ObservacaoDocumentos","ParecerInstalacao","DataParecerInstalacao","ObservacaoInstalacao","MotivoReprovacao","RespTecnico.Nome","Ocupante.Nome"]
                        &filter=[{"property":"CodigoSolicCompart","operator":"equal","value":"${codigoSolicCompart}","and":true},{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]`
                : `/api/v1/SolicitacaoCompartilhamentoAnalise?page=1&start=0&limit=9999
                        &fields=["CodigoSolicCompart","CodigoVisual","Id","Analise","Situacao","CodigoResponsavelTecnico","CodigoOcupante","Usuario","CodigoCidade","Bairro","TipoCabo","NomeRepresentante","CpfRepresentante","EmailRepresentante","QtdePontos","DataCadastro","DataApresentacao","PrazoAnalise","PrazoAvisoInstalacao","DataInicioInstalacao","DataTerminoInstalacao","DataAprovacao","ParecerRepresentante","DataParecerRepresentante","ObservacaoRepresentante","ParecerProjeto","DataParecerProjeto","ObservacaoProjeto","ParecerDocumentos","DataParecerDocumentos","ObservacaoDocumentos","ParecerInstalacao","DataParecerInstalacao","ObservacaoInstalacao","MotivoReprovacao","RespTecnico.Nome","Ocupante.Nome"]
                        &filter=[{"property":"CodigoSolicCompart","operator":"equal","value":"${codigoSolicCompart}","and":true}, {"property":"DataApresentacao","operator":"equal","value":"${filtro}","and":true},{"property":"CodigoResponsavelTecnico","value":"${codigoResp}","and":true,"not":false}]`
        });

        return response.data;
    }

    async RecuperarUltimaAnaliseAcesso(codigoSolicitacao) {
        const response = await api({
            method: "GET",
            url: `/api/v1/AnaliseSolicitacao/?page=1&start=0&limit=1&fields=["Id","CodigoSolicitacao","Sequencia","DataApresentacao","ParecerDocumentos","DataDocumento","MotReprovDocumento","RessalvaDocumento","ParecerEquipamento","DataEquipamento","MotReprovEquipamento","RessalvaEquipamento","ParecerProjeto","DataProjeto","MotReprovProjeto","RessalvaProjeto","ParecerViabTecnica","DataViabTecnica","MotReprovViabTecnica","RessalvaViabTecnica","ParecerGeral","Situacao","GerarObra","DataAnalise","DataPrazo","CodigoDocumentoParecer","SolicitacaoDeAcesso.Id","SolicitacaoDeAcesso.Situacao","SolicitacaoDeAcesso.CodigoResponsavelTec","SolicitacaoDeAcesso.CodigoTipoGeracao","SolicitacaoDeAcesso.ResponsavelTec.Id","SolicitacaoDeAcesso.ResponsavelTec.Situacao","SolicitacaoDeAcesso.ResponsavelTec.Email","SolicitacaoDeAcesso.ResponsavelTec.Nome","SolicitacaoDeAcesso.ResponsavelTec.Empresa","SolicitacaoDeAcesso.ResponsavelTec.DddFone","SolicitacaoDeAcesso.ResponsavelTec.Celular","SolicitacaoDeAcesso.ResponsavelTec.CPF","SolicitacaoDeAcesso.ResponsavelTec.Crea","SolicitacaoDeAcesso.ResponsavelTec.DataValidadeCrea","SolicitacaoDeAcesso.ResponsavelTec.Ativo","SolicitacaoDeAcesso.ResponsavelTec.DataCadastro","SolicitacaoDeAcesso.ResponsavelTec.DataAprovacaoCadastro","SolicitacaoDeAcesso.ResponsavelTec.DataPrazoAnalise","SolicitacaoDeAcesso.ResponsavelTec.DataEnvioSolicitacao"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoSolicitacao","operator":"equal","value":"${codigoSolicitacao}","and":true}]`
        });

        return response.data;
    }

    async EnviarParaAnalise(codigoSolicitacao) {
        const response = await api({
            method: "PUT",
            url: `api/v1/SolicitacaoDeAcesso/${codigoSolicitacao}/EnviarParaAnalise`
        });

        return response.data;
    }

    async DownloadParecerSolicA(dto) {
        const response = await api({
            method: "POST",
            url: `/api/v1/AnaliseSolicitacao/VisualizarAnexo`,
            data: JSON.stringify(dto)
        });

        return response.data;
    }


    async DownloadParecerSolicAB(codigoDocumento) {
        const response = await api({
            method: "POST",
            url: "api/v1/SolicitacaoDeAcesso/RealizarDownloadDocumento",
            data: {
                CodigoDocumento: codigoDocumento
            }
        });

        return response.data;
    }

    async EnviarVistoriaParaAnalise(codigoSolicitacao) {
        const response = await api({
            method: "PUT",
            url: `api/v1/SolicitacaoVistoria/${codigoSolicitacao}/EnviarParaAnalise`
        });

        return response.data;
    }

    async RecuperarUltimaAnaliseVistoria(codigoSolicitacao) {
        const response = await api({
            method: "GET",
            url: `/api/v1/SolicitacaoVistoriaAnalise/?page=1&start=0&limit=1&fields=["Id","CodigoSolicitacaoVistoria","Sequencia","DataApresentacao","ParecerAnalise","Situacao","DataAnalise","DataPrazo","GeraServico","GeraAgendamento","SolicitacaoVistoria.Id","SolicitacaoVistoria.Situacao","SolicitacaoVistoria.SituacaoAgendamento","SolicitacaoVistoria.Protocolo","SolicitacaoVistoria.DataCadastro","SolicitacaoVistoria.PrazoAnalise","SolicitacaoVistoria.Observacao","SolicitacaoVistoria.DataConclusaoInstalacaoGD","SolicitacaoVistoria.CodigoResponsavelTecnico","SolicitacaoVistoria.CodigoSolicitacaoAcesso","SolicitacaoVistoria.SolicitacaoDeAcesso.Id","SolicitacaoVistoria.SolicitacaoDeAcesso.Situacao","SolicitacaoVistoria.SolicitacaoDeAcesso.Inscricao","SolicitacaoVistoria.SolicitacaoDeAcesso.CodigoUC", "CodigoSolicitacaoCod", "QtdeAnexos"]&sort=[{"property":"Id","direction":"DESC"}]&filter=[{"property":"CodigoSolicitacaoVistoria","operator":"equal","value":"${codigoSolicitacao}","and":true}]`
        });

        return response.data;
    }

    async RecuperarUltimaAnaliseConsultaPrevia(codigoConsultaPrevia) {
        const response = await api({ 
            method: "GET", 
            url: `/api/v1/ConsultaPreviaAnalise/RecuperarAnalise/${codigoConsultaPrevia}` 
        });
        return response.data;
    }

    async RecuperarUltimaAnaliseAnaliseProjeto(codigoAnaliseProjeto) {
        const response = await api({ 
            method: "GET", 
            url: `/api/v1/AnaliseProjetoAnalise/RecuperarAnaliseAtual/${codigoAnaliseProjeto}` 
        });
        return response.data;
    }

    async VisualizarDocumentoParecerAnaliseProjeto(id) {
        const response = await api({
            method: "GET",
            url: `/api/v1/AnaliseProjetoAnalise/VisualizarDocumentoParecer/${id}`,
        });
        return response.data;
    }

    async VisualizarDocumentoParecerConsultaPrevia(id) {
        const response = await api({
            method: "GET",
            url: `/api/v1/ConsultaPreviaAnalise/VisualizarDocumentoParecer/${id}`,
        });
        return response.data;
    }

    async ListarSolicitacoesVistoriaAnalise(codigoSolicitacaoVistoria, filtro) {
        const response = await api({
            method: "GET",
            url: filtro.trim() === ""
                ? `/api/v1/SolicitacaoVistoriaAnalise?page=1&start=0&limit=999&fields=["Id","CodigoSolicitacaoVistoria","Sequencia","DataApresentacao","ParecerAnalise","Situacao","DataAnalise","DataPrazo","GeraServico","GeraAgendamento","SolicitacaoVistoria.Id","SolicitacaoVistoria.Situacao","SolicitacaoVistoria.SituacaoAgendamento","SolicitacaoVistoria.Protocolo","SolicitacaoVistoria.DataCadastro","SolicitacaoVistoria.PrazoAnalise","SolicitacaoVistoria.Observacao","SolicitacaoVistoria.DataConclusaoInstalacaoGD","SolicitacaoVistoria.CodigoResponsavelTecnico","SolicitacaoVistoria.CodigoSolicitacaoAcesso","SolicitacaoVistoria.SolicitacaoDeAcesso.Id","SolicitacaoVistoria.SolicitacaoDeAcesso.Situacao","SolicitacaoVistoria.SolicitacaoDeAcesso.Inscricao","SolicitacaoVistoria.SolicitacaoDeAcesso.CodigoUC", "SolicitacaoVistoria.SolicitacaoDeAcesso.Nome", "CodigoSolicitacaoCod", "QtdeAnexos"]&filter=[{"property":"CodigoSolicitacaoVistoria","operator":"equal","value":"${codigoSolicitacaoVistoria}","and":true}]&sort=[{"property":"Id","direction":"DESC"}]`
                : `/api/v1/SolicitacaoVistoriaAnalise?page=1&start=0&limit=999&fields=["Id","CodigoSolicitacaoVistoria","Sequencia","DataApresentacao","ParecerAnalise","Situacao","DataAnalise","DataPrazo","GeraServico","GeraAgendamento","SolicitacaoVistoria.Id","SolicitacaoVistoria.Situacao","SolicitacaoVistoria.SituacaoAgendamento","SolicitacaoVistoria.Protocolo","SolicitacaoVistoria.DataCadastro","SolicitacaoVistoria.PrazoAnalise","SolicitacaoVistoria.Observacao","SolicitacaoVistoria.DataConclusaoInstalacaoGD","SolicitacaoVistoria.CodigoResponsavelTecnico","SolicitacaoVistoria.CodigoSolicitacaoAcesso","SolicitacaoVistoria.SolicitacaoDeAcesso.Id","SolicitacaoVistoria.SolicitacaoDeAcesso.Situacao","SolicitacaoVistoria.SolicitacaoDeAcesso.Inscricao","SolicitacaoVistoria.SolicitacaoDeAcesso.CodigoUC", "SolicitacaoVistoria.SolicitacaoDeAcesso.Nome", "CodigoSolicitacaoCod", "QtdeAnexos"]&filter=[{"property":"CodigoSolicitacaoVistoria","operator":"equal","value":"${codigoSolicitacaoVistoria}","and":true}, {"property":"DataApresentacao","operator":"greaterOrEqual","value":"${filtro}","and":true}]`
        });

        return response.data;
    }

    async RecuperarDocumentosSolicAcesso(codigoAnalise) {
        const response = await api({
            method: "GET",
            url: `/api/v1/SolicitacaoAnaliseVincDocs/?page=1&start=0&limit=25&fields=["Id","CodigoSolicitacaoAnalise","CodigoDocumento","TipoDocumento","NomeArquivo","ExtensaoDocumentoParecer"]&filter=[{"property":"CodigoSolicitacaoAnalise","operator":"equal","value":"${codigoAnalise}","and":true},{"property":"TipoDocumento","operator":"in","value":[1, 2],"and":true}]`
        });

        return response.data;
    }

    async RecuperarParecerAnaliseAssinado(dto) {
        const response = await api({
            method: "POST",
            url: `/api/v1/AnaliseSolicitacao/ParecerAssinado`,
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    async listarAnexos(codigoSolicitacaoAnalise) {
        let url = `/api/v1/SolicitacaoAnaliseVincDocs?page=1&start=0&limit=999&fields=["NomeArquivo","ExtensaoDocumentoParecer","Id","CodigoConsultaAcessoAnalise","CodigoSolicitacaoAnalise","CodigoDocumento","TipoDocumento"]&filter=[{"property":"CodigoSolicitacaoAnalise","value":${codigoSolicitacaoAnalise},"and":true,"not":false},{"property":"TipoDocumento","operator":"in","value":[3],"and":true,"not":false}]`;

        const response = await api({
            method: "GET",
            url: url
        });

        return response.data;
    }

    async downloadAnexo(dto) {
        let url = `/api/v1/SolicitacaoAnaliseVincDocs/RealizarDownloadDocumentoSolicitacaoAcessoAnalise`;

        const response = await api({
            method: "POST",
            url,
            data: JSON.stringify(dto)
        });

        return response.data;
    }

    //SolicitacaoCompartilhamentoDocs
    async visualizarParecerAnalise(codigoSolicitacao, codigoDocumento) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolicitacaoCompartilhamentoDocs/VisualizarParecerAnalise/${codigoSolicitacao}/${codigoDocumento}`
        });

        return response.data;
    }

    async recuperarRelacionamentoOperacional(codigoSolicitacao, codigoDocumento) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolicitacaoCompartilhamentoDocs/RecuperarRelacionamentoOperacional/${codigoSolicitacao}`
        });

        return response.data;
    }

    async recuperarImagensDaSolicitacao(codigoSolicitacaoCod) {
        const response = await api({
            method: "GET",
            url: `api/v1/SolicitacaoVistoriaAnalise/RecuperarImagensDaSolicitacao/${codigoSolicitacaoCod}`
        });

        return response.data;
    }
}

export default new Analises();